export default "__VITE_ASSET__36295140__"